'use client'

import { useState } from 'react'
import Link from 'next/link'
import { CircleUserRound, Menu } from 'lucide-react'

import { logoutUser } from '@/actions/user-auth'
import {
  Sheet,
  SheetClose,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from '@/components/ui/sheet'

import { NavLinks, mobileNavLinkClass as mobileLinkClass } from './NavLinks'

interface MobileNavProps {
  isEdukator: boolean
  displayName: string | null
}

export function MobileNav({ isEdukator, displayName }: MobileNavProps) {
  const [open, setOpen] = useState(false)

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger
        className="hover:bg-accent focus-visible:ring-ring inline-flex items-center justify-center rounded-md p-2 focus-visible:outline-none focus-visible:ring-2 md:hidden"
        aria-label="Otvori meni"
      >
        <Menu aria-hidden="true" className="h-6 w-6" />
      </SheetTrigger>

      <SheetContent side="right" className="w-72">
        <SheetHeader>
          <SheetTitle>Navigacija</SheetTitle>
        </SheetHeader>

        <nav aria-label="Glavna navigacija" className="mt-6 flex flex-col gap-1">
          <NavLinks variant="mobile" isEdukator={isEdukator} />

          <div className="my-3 border-t" />

          {displayName ? (
            <>
              <SheetClose asChild>
                <Link href="/nalog" className={`${mobileLinkClass} flex items-center gap-2`}>
                  <CircleUserRound aria-hidden="true" className="text-primary h-5 w-5" />
                  <span>
                    <span className="sr-only">Moj nalog — prijavljeni ste kao </span>
                    {displayName}
                  </span>
                </Link>
              </SheetClose>
              <form action={logoutUser}>
                <button type="submit" className={`${mobileLinkClass} w-full text-left`}>
                  Odjava
                </button>
              </form>
            </>
          ) : (
            <>
              <SheetClose asChild>
                <Link href="/prijava" className={mobileLinkClass}>
                  Prijava
                </Link>
              </SheetClose>
              <SheetClose asChild>
                <Link
                  href="/registracija"
                  className="bg-primary text-primary-foreground hover:bg-primary/90 focus-visible:ring-ring mt-1 block rounded-md px-3 py-3 text-center text-base font-medium focus-visible:outline-none focus-visible:ring-2"
                >
                  Registracija
                </Link>
              </SheetClose>
            </>
          )}
        </nav>
      </SheetContent>
    </Sheet>
  )
}
